import {Util} from 'yougile-util'

export class Cookies {
  private static domain(host: string): string {
    if (Util.isIP(host)) {
      return host
    }
    return host.split('.').slice(-2).join('.')
  }

  static setItem(
    key: string,
    value: string,
    maxAgeInSecondsOrExpires: number | Date,
    host: string,
    path = '/'
  ) {
    let expirationValue: string
    if (maxAgeInSecondsOrExpires instanceof Date) {
      expirationValue = `expires=${maxAgeInSecondsOrExpires.toUTCString()}`
    } else {
      expirationValue = `max-age=${maxAgeInSecondsOrExpires}`
    }
    const domain = this.domain(host)
    const isSecure = document.location.protocol === 'https:'
    document.cookie = `${key}=${value}; ${expirationValue}; path=${path};${
      isSecure ? ' secure;' : ''
    } domain=${domain};`
    document.cookie = `${key}=${value}; ${expirationValue}; path=${path};${
      isSecure ? ' secure;' : ''
    } domain=${host};`
  }

  static getItem(key: string): string | undefined {
    return document.cookie
      .split('; ')
      .find(str => str.startsWith(`${key}=`))
      ?.split('=')[1]
  }

  static removeItem(key: string, host: string) {
    const domain = this.domain(host)
    const isSecure = document.location.protocol === 'https:'
    document.cookie = `${key}=; expires=${new Date(0).toUTCString()}; path=/;${
      isSecure ? ' secure;' : ''
    } domain=${domain};`
    document.cookie = `${key}=; expires=${new Date(0).toUTCString()}; path=/;${
      isSecure ? ' secure;' : ''
    } domain=${host};`
  }
}
